<template>
	<div class="content">
		<div class="fLeft">
			<p class="title" v-if="moduleDataSource.title">{{ moduleDataSource.title }}</p>
			<p class="date">
				<span v-if="moduleDataSource.projectType"
					style="padding:2px 10px;background:#3CA079;color:#fff;border-radius: 8px;">{{
						moduleDataSource.projectType }}</span>
				<span v-if="moduleDataSource.address">项目地址：{{ moduleDataSource.address }}</span>
				<span v-if="moduleDataSource.buildNature">项目性质：{{ moduleDataSource.buildNature }}</span>
				<span v-if="moduleDataSource.issue_date || moduleDataSource.merchants_land_fbrq">{{
					moduleDataSource.issue_date || moduleDataSource.merchants_land_fbrq.substring(0, 10) }}</span>
			</p>
			<div v-html="removeHtmlStyle(moduleDataSource.content)" class="txt"></div>
			<div class="address" v-show="moduleDataSource.mapPoint">
				<div class="tTitle">
					<span class="line line1"></span>
					<span>项目位置</span>
					<span class="line line2"></span>
				</div>
				<div>
					<div class="map cfff" id="map"></div>
				</div>
			</div>
			<div class="address" v-if="moduleDataSource.voideo">
				<div class="tTitle">
					<span class="line line1"></span>
					<span>项目视频</span>
					<span class="line line2"></span>
				</div>
				<div style="width:60%;margin:0 auto;">
					<vueVideoPlayer :src="moduleDataSource.voideo" />
				</div>
			</div>
		</div>
		<div class="concat-wrap" v-if="moduleDataSource.isShowConcat == '是' && moduleDataSource.phone">
			<i class="el-icon-phone-outline" style="color: #fff;font-size: 48px;"></i>
			<div class="concat">
				<div class="cfff fontSize20" style="line-height: 26px;">{{ moduleDataSource.name }}</div>
				<div class="cfff fontSize30" style="line-height: 36px;">{{ moduleDataSource.phone }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import vueVideoPlayer from '@/components/base/MyVideoPlayer'
export default {
	name: 'HuaxianProjectDetail',
	props: {
		moduleDataSource: {
			type: Object,
			default: () => { }
		},
	},
	components: {
		vueVideoPlayer
	},
	data() {
		return {
			showMapInfo: false,
			map: null,
			timeout: null
		}
	},
	methods: {
		showMap() {
			let infoTitle = this.moduleDataSource.title
			let mapPoint = this.moduleDataSource.mapPoint
			let infoContent = this.moduleDataSource.address

			if (mapPoint) {
				this.showMapInfo = true
			} else {
				this.showMapInfo = false
				return
			}

			setTimeout(() => {
				// 创建高德地图实例
				this.map = new AMap.Map('map', {
					zoom: 15,
					center: mapPoint.split(',').map(Number),
					resizeEnable: true
				})

				// 异步加载插件
				AMap.plugin(['AMap.Scale', 'AMap.ToolBar'], () => {
					// 添加比例尺控件
					this.map.addControl(new AMap.Scale())

					// 添加缩放控件
					this.map.addControl(new AMap.ToolBar({
						position: 'RB'
					}))
				})

				// 设置中心点坐标
				var point = new AMap.LngLat(mapPoint.split(',')[0], mapPoint.split(',')[1])

				// 创建多边形
				this.drawPolygon(
					[
						new AMap.LngLat(116.50497, 39.328019),
						new AMap.LngLat(116.504907, 39.327322),
						new AMap.LngLat(116.506488, 39.327273),
						new AMap.LngLat(116.50576, 39.32841)
					],
					[
						{
							label: '地块面积',
							value: '3.4亩'
						}, {
							label: '承包期限止',
							value: '2029-12-30'
						}
					]
				)

				// 创建多边形
				this.drawPolygon(
					[
						new AMap.LngLat(116.506631, 39.326373),
						new AMap.LngLat(116.507332, 39.325173),
						new AMap.LngLat(116.509937, 39.327336),
						new AMap.LngLat(116.509398, 39.328829)
					],
					[
						{
							label: '地块面积',
							value: '5.4亩'
						}, {
							label: '承包期限止',
							value: '2029-12-30'
						}
					]
				)

				// 开启鼠标滚轮缩放
				this.map.setStatus({ scrollWheel: true })
			}, 1000)
		},
		drawPolygon(options, value) {
			const polygon = new AMap.Polygon({
				path: options,
				strokeColor: '#3366FF',
				strokeWeight: 2,
				strokeOpacity: 0.5,
				fillColor: '#3366FF',
				fillOpacity: 0.15
			})

			polygon.value = value
			polygon.on('click', this.showPolygonInfo)
			this.map.add([polygon])
		},
		showPolygonInfo(e) {
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				const polygon = e.target
				var sContent = ''
				polygon.value.forEach(item => {
					sContent += `<div style="padding:0 10px 0px 10px"><p style="font-size:14px;color:#000;">${item.label}:${item.value}</p></div>`
				})

				// 创建信息窗口
				const infoWindow = new AMap.InfoWindow({
					content: sContent,
					offset: new AMap.Pixel(0, -30)
				})

				infoWindow.open(this.map, e.lnglat)
			}, 20)
		}
	},
	mounted() {
		// // 动态加载高德地图JS
		// const script = document.createElement('script')
		// script.src = 'https://webapi.amap.com/maps?v=2.0&key=06a17e15ce6a3fe9b4a9dc50cfe113cc'
		// script.onload = () => {
		// }
		// document.head.appendChild(script)
		this.showMap()
	},
	beforeDestroy() {
		if (this.map) {
			this.map.destroy()
			this.map = null
		}
		if (this.timeout) {
			clearTimeout(this.timeout)
		}
	}
}
</script>

<style scoped>
.content {
	overflow: hidden;
}

.title {
	font-family: PingFangSC-Medium;
	font-size: 28px;
	color: #181818;
	font-weight: 500;
	margin-bottom: 20px;
	text-align: center;
}

.date {
	font-size: 18px;
	color: #999;
	text-align: center;
	margin-bottom: 30px;
}

.date span {
	margin: 0 20px;
}

.txt {
	font-size: 16px;
	color: #333;
	margin-top: 30px;
}

.txt /deep/ p {
	line-height: 2;
	font-size: 16px;
	color: #333;
}

/deep/ .BMap_bubble_pop img {
	/* display: none; */
}

.txt /deep/ p span {
	line-height: 2 !important;
	font-size: 16px !important;
	color: #333 !important;
}

.txt /deep/ .rich-img {
	max-width: 100%;
	margin: 0 auto;
	height: auto;
}

.address {
	margin-top: 20px;
}

.addressImg {
	width: 100%;
	margin-bottom: 40px;
}

.line1 {
	background: linear-gradient(to left, rgba(60, 160, 121, 1), rgba(60, 160, 121, 0));
}

.map {
	width: 60%;
	margin: 0 auto;
	height: 500px;
	text-align: center;
	font-weight: bold;
}

.concat {
	width: 204px;
	padding-top: 10px;
	height: 70px;
	padding-left: 10px;
}

.concat-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	right: 0;
	top: 400px;
	background: rgba(60, 160, 121, 1);
	border-radius: 12px 0 0 12px;
	width: 285px;
	height: 82px;
}
</style>
